import { render, staticRenderFns } from "./plan-estudios.vue?vue&type=template&id=9f53063c&"
import script from "./plan-estudios.component.ts?vue&type=script&lang=ts&"
export * from "./plan-estudios.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports